export const getDefaultValues = (subItemDetails) => ({
  ApplicationMenuLable: subItemDetails?.ApplicationMenuLable || '',
  ApplicationMenuUrl: subItemDetails?.ApplicationMenuUrl || '',
  ApplicationMenuOrderIndex: subItemDetails?.ApplicationMenuOrderIndex || '',
  ApplicationMenuLogo: subItemDetails?.ApplicationMenuLogo || '',
  ApplicationMenuShowTextMenu: !!subItemDetails?.ApplicationMenuShowTextMenu ? true : false,
});
